export default __webpack_public_path__ + "static/media/logo3.e228a989.png";